import apiVersion from '../_helpers/api-version';
import axiosInstance from '../_helpers/axiosConfig'

import { authHeader } from '../_helpers/auth-header';
import { store } from '../_helpers/store';

export const questionLibraryService = {
  get,
  save,
  update,
  getByProvider,
}

function getByProvider() {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/question`,
    headers: authHeader(),
  }).then((response) => {
    return response.data;
  });
}

function get(questionId) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/question/${questionId}`,
    headers: authHeader(),
  }).then((response) => {
    return response.data;
  });
}

function update(questionId, question, applyAll) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'PATCH',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/question/${questionId}`,
    headers: authHeader(),
    data: { question, applyAll }
  });
};

function save(question) {
  const clientId = store.getState().client.id;

  return axiosInstance.request({
    method: 'POST',
    url: `${process.env.REACT_APP_API_URL}/${apiVersion()}/client/provider/${clientId}/question`,
    headers: authHeader(),
    data: { question }
  });
}